'use strict';

angular.module('betosyswebapp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('login', {
        parent: 'app',
        url: '/login',
        views: {
          'content@app': {
            templateUrl: 'components/login/login.tpl.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        },
        resolve: {
          $title: function () {
            return 'BetoTrack Login';
          },
          $sibebar: ['AdmStatusService', function (AdmStatusService) {
            AdmStatusService.setSidebarVisible(false);
            return false;
          }]
        }
      });
  });



// WEBPACK FOOTER //
// ./.tmp/components/login/login.route.js